/* eslint no-new: "off" */
import ClipboardJS from 'clipboard';

$(document).ready(() => {
  new ClipboardJS('.clipboard_btn');
});
